module.exports = __webpack_public_path__ + "img/Apoptosis-BRME_GSE179572.07175825.png";